import { LightningBoltIcon } from '@heroicons/react/outline';

import styles from '../agents.module.css';

import clsxm from '@/lib/clsxm';

import type { DemoStep } from './types';
import { useChannelsT } from './useChannelsT';
import { CheckGlyph, delay } from '../primitives';

/** What the agent did out of sight while it answered. */
export default function BehindTheScenes({ steps }: { steps: DemoStep[] }) {
  const { t } = useChannelsT();

  return (
    <div className='rounded-2xl bg-[#0d0c1f] p-4 text-start text-white shadow-[0_30px_70px_-25px_rgba(8,6,40,0.8)] ring-1 ring-white/10'>
      <p className='flex items-center gap-2 text-xs font-medium text-white/60'>
        <LightningBoltIcon className='h-3.5 w-3.5' />
        {t('Behind the scenes')}
      </p>
      <ol className='mt-3 space-y-2.5'>
        {steps.map(({ icon: Icon, title, via, at }) => (
          <li
            key={title}
            className={clsxm(styles.enter, 'flex items-center gap-3')}
            style={delay(at)}
          >
            <span className='flex h-7 w-7 flex-none items-center justify-center rounded-full bg-white/10'>
              <Icon className='h-3.5 w-3.5 text-white/80' />
            </span>
            <span className='min-w-0 flex-1'>
              <span className='block text-[13px] font-semibold leading-snug'>
                {title}
              </span>
              <span className='block truncate text-[11px] text-white/55'>
                {via}
              </span>
            </span>
            <CheckGlyph className='h-4 w-4 text-emerald-400' />
          </li>
        ))}
      </ol>
    </div>
  );
}
